module.exports = __webpack_public_path__ + "static/compass-36b65072e82cbfe80ba57058be3d1cc9.png";